<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="width: 500px">
            <v-responsive :aspect-ratio="16 / 9">
              <v-card-title primary-title>
                <div>
                  <div class="headline pl-2 pa-1">{{ $t("customers.createRestaurant.heading") }}</div>
                </div>
              </v-card-title>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">
                <v-flex>
                  <v-flex>
                    <v-autocomplete
                      v-model="returnObject"
                      clearable
                      :items="restaurants"
                      :loading="isLoading"
                      :search-input.sync="search"
                      outline
                      dense
                      :label="$t('customers.createRestaurant.restaurants')"
                      item-text="name"
                      item-value="name"
                      :placeholder="$t('customers.createRestaurant.selectRestaurant')"
                      no-filter
                      return-object
                    >
                      <template slot="item" slot-scope="restaurants">
                        <v-list-tile-content>
                          <v-list-tile-title
                            v-html="restaurants.item.name"
                          ></v-list-tile-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      outline
                      v-model="model.username"
                      :rules="[rules.email]"
                      :label="$t('customers.createRestaurant.email')"
                      type="email"
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      outline
                      v-model="model.password"
                      :rules="[rules.password]"
                      :label="$t('customers.createRestaurant.password')"
                      type="password"
                      dense
                    ></v-text-field
                  ></v-flex>

                  <v-flex>
                    <v-text-field
                      outline
                      v-model="model.phone_number"
                      :rules="[rules.phoneNumber]"
                      :label="$t('customers.createRestaurant.phoneNumber')"
                      type="phone"
                      dense
                    ></v-text-field>
                  </v-flex>
                </v-flex>
                <v-btn
                  :loading="loading"
                  block
                  @click="createRestaurant"
                  color="secondary"
                  dark
                  >{{ $t("common.create") }}</v-btn
                >
              </v-form>
            </v-responsive>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  title() {
    return this.$t("customers.createRestaurant.title");
  },
  data: () => ({
    restaurants: [],
    returnObject: "",
    results: [],
    allResults: [],
    isLoading: false,
    search: null,
    loading: false,
    error: false,
    model: {
      full_name: "",
      username: "",
      password: "",
      phone_number: "",
      passenger_type: "RESTAURANT",
      restaurant_id: 0,
    },
    email: undefined,
    form: false,
    isLoading: false,
    password: undefined,
  }),
  computed: {
    rules() {
      return {
        email: (v) => !!(v || "").match(/@/) || this.$t("customers.createRestaurant.validEmail"),
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("customers.createRestaurant.invalidLength", { length: len }),
        password: (v) =>
          !!(v || "").match(/^.{8,15}$/) || this.$t("customers.createRestaurant.passwordLength"),
        phoneNumber: (v) =>
          // (!!v &&
          //   v.search(/^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/) !== -1) ||
          // "Not a valid phone number !",

          (!!v && v.search(/^(00|\+)?[1-9]\d{6,}$$/) !== -1) ||
          this.$t("customers.createRestaurant.invalidPhone"),

        required: (v) => !!v || this.$t("customers.createRestaurant.requiredField"),
      };
    },
  },

  watch: {
      search(val) {
        this.isLoading = true;
        const params = new URLSearchParams(this.initialSearchParams);
        params.append("search", val);
        this.axios
          .get("restaurant", { params })
          .then((res) => {
            this.restaurants = res.data.data.data.map((item) => ({
              ...item,
            }));
          })
          .catch((err) => console.log(err))
          .finally(() => (this.isLoading = false));
      },
    },

  methods: {
    createRestaurant() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        this.model.restaurant_id = this.returnObject.id;
        this.model.full_name = this.returnObject.name;
        this.axios
          .post(this.api.ACTIONS.CREATE_PASSENGER, {
            ...this.model,
            provider: "users",
          })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("customers.createRestaurant.restaurantCreated"), "green");
            this.$router.push("/restaurantsUsers");
          })
          .catch((err) => {
            console.log(err.message);
            this.error = true;
            let response = err.response;
            if (response) {
              window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              console.log(response.data);
            } else {
              window.getApp.$emit("SHOW_TOAST", this.$t("customers.createRestaurant.checkInfo"), "red");
            }
          })
          .then(() => (this.loading = false));
      }
      // }
    },
  },
};
</script>
